import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import firebase from "../firebase";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

const Navbar = () => {
  const db = firebase.firestore();

  const [countValue, setCountValue] = useState([]);

  const increment = firebase.firestore.FieldValue.increment(1);

  useEffect(() => {
    db.collection("Votess").onSnapshot((snapshot) =>
      setCountValue(snapshot.docs.map((doc) => doc.data()))
    );
  }, []);

  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);

  function Pop(e) {
    var storyRef = db.collection("Votess").doc("likes");
    storyRef.update({ count: increment });
    console.log("vote added");
    // Quick check if user clicked the button using a keyboard
    for (let i = 0; i < 30; i++) {
      // We call the function createParticle 30 times
      // As we need the coordinates of the mouse, we pass them as arguments
      createParticle(e.clientX, e.clientY);
      console.log("X: " + e.clientX);
      console.log("Y: " + e.clientY);
    }
  }

  function createParticle(x, y) {
    const particle = document.createElement("particle");
    document.body.appendChild(particle);

    // Calculate a random size from 5px to 25px
    const size = Math.floor(Math.random() * 20 + 5);
    particle.style.position = "fixed";
    particle.style.left = 0;
    particle.style.top = 0;
    particle.style.borderRadius = "50%";
    particle.style.pointerEvents = "none";
    particle.style.opacity = 0;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    // Generate a random color in a blue/purple palette
    particle.style.background = `hsl(${Math.random() * 90 + 180}, 70%, 60%)`;

    // Generate a random x & y destination within a distance of 75px from the mouse
    const destinationX = x + (Math.random() - 0.5) * 2 * 175;
    const destinationY = y + (Math.random() - 0.5) * 2 * 175;

    // Store the animation in a variable as we will need it later
    const animation = particle.animate(
      [
        {
          // Set the origin position of the particle
          // We offset the particle with half its size to center it around the mouse
          transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
          opacity: 1
        },
        {
          // We define the final coordinates as the second keyframe
          transform: `translate(${destinationX}px, ${destinationY}px)`,
          opacity: 0
        }
      ],
      {
        // Set a random duration from 500 to 1500ms
        duration: Math.random() * 1000 + 500,
        easing: "cubic-bezier(0, .9, .57, 1)",
        // Delay every particle with a random value of 200ms
        delay: Math.random() * 200
      }
    );

    // When the animation is complete, remove the element from the DOM
    animation.onfinish = () => {
      particle.remove();
    };
  }

  return (
    <div className="container">
      <div data-aos="fade-down" className="row row-padding">
        <div className="grow col">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/" className="title-underline-color">
                  Home
                </Link>
              </li>
              <li class="breadcrumb-item">
                <a
                  href="https://dunningkrugervote.vercel.app"
                  className="title-underline-color">
                  Play
                </a>
              </li>
              <li class="breadcrumb-item">
                <Link to="/about" className="title-underline-color">
                  About
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div
        data-aos="fade-down"
        data-aos-delay="50"
        className="row row-padding-small">
        <div data-aos="fade-down" data-aos-delay="50" className="col">
          <ul class="nav  end-navlink ">
            <li className="stay_cursor nav-item">
              <button
                onClick={(e) => Pop(e)}
                type="button"
                className="btn stay_cursor btn-dark-light">
                <svg
                  unselectable="on"
                  className="heart stay_cursor"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tooltip on top"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16">
                  <path
                    fill-rule="evenodd"
                    d="M8.49 10.92C19.412 3.382 11.28-2.387 8 .986 4.719-2.387-3.413 3.382 7.51 10.92l-.234.468a.25.25 0 1 0 .448.224l.04-.08c.009.17.024.315.051.45.068.344.208.622.448 1.102l.013.028c.212.422.182.85.05 1.246-.135.402-.366.751-.534 1.003a.25.25 0 0 0 .416.278l.004-.007c.166-.248.431-.646.588-1.115.16-.479.212-1.051-.076-1.629-.258-.515-.365-.732-.419-1.004a2.376 2.376 0 0 1-.037-.289l.008.017a.25.25 0 1 0 .448-.224l-.235-.468ZM6.726 1.269c-1.167-.61-2.8-.142-3.454 1.135-.237.463-.36 1.08-.202 1.85.055.27.467.197.527-.071.285-1.256 1.177-2.462 2.989-2.528.234-.008.348-.278.14-.386Z"
                  />
                </svg>{" "}
                <span
                  unselectable="on"
                  class="badge stay_cursor ballon-heart badge-light">
                  {countValue.map(({ count }) => count)}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
